import { useNomineesCtx } from "./contexts/nomination";
import Slider from "./slider";

export default function MainContent() {
  const { nominees } = useNomineesCtx();

  return (
    <div className="">
      <Slider nominees={nominees} />
    </div>
  );
}
